import React, { useEffect, useRef } from "react";
import CloudImage360View from "js-cloudimage-360-view";

interface ProductView360Props {
    amount: number; // Total number of images
    imageList?: string[]; // Optional: Array of image URLs if not using sequential naming
    spinReverse?: boolean; // Optional: Reverse spin direction
    autoplay?: boolean; // Optional: Auto rotate the view
    speed?: number; // Optional: Rotation speed for autoplay
    boxShadow?: string; // Optional: CSS box shadow
    className?: string; // Optional: Additional CSS classes
}

const ProductView360: React.FC<ProductView360Props> = ({
    amount,
    imageList,
    autoplay = false,
    spinReverse = false,
    speed = 50,
    boxShadow,
    className = "",
}) => {
    const viewerRef = useRef<any>(null);
    const containerIdRef = useRef(`cloudimage-360-${Math.random().toString(36).substring(2, 15)}`);

    useEffect(() => {
        const container = document.getElementById(containerIdRef.current);

        viewerRef.current = new CloudImage360View();
        viewerRef.current.init(container, {
            autoplay: autoplay,
            bottomCircle: true,
            playOnce: true,
            spinReverse: spinReverse,
            hide360Logo: true,
            speed: speed,
            fullscreen: true,
            magnifier: 3,
            amountX: amount,
            imageListX: JSON.stringify(imageList),
        });

        return () => {
            if (viewerRef.current) {
                viewerRef.current.destroy();
            }
        };
    }, [amount, imageList, autoplay, spinReverse, speed]);

    return (
        <div
            id={containerIdRef.current}
            className={`${className} object-contain mx-auto`}
            style={{
                boxShadow: boxShadow,
            }}
        ></div>
    );
};

export default ProductView360;
